module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-nav-item",
    class: _vm.rootClasses
  }, [_c('div', {
    staticClass: "main-nav-item--wrap"
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onMenuClickaway),
      expression: "onMenuClickaway"
    }],
    staticClass: "main-nav-item--concentrator",
    on: {
      "mouseenter": function($event) {
        _vm.onMenuHover(true)
      },
      "mouseleave": function($event) {
        _vm.onMenuHover(false)
      }
    }
  }, [_c('a', {
    staticClass: "u-reset main-nav-item--link",
    class: [_vm.isShown ? 'main-nav-item--link__has-visible-sub-nav' : ''],
    attrs: {
      "href": _vm.child.path
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onMenuItemClick($event)
      }
    }
  }, [_vm._t("link")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "trs-menu-fade"
    }
  }, [(_vm.isShown) ? _c('cmp-sub-nav', {
    staticClass: "main-nav-item--sub-nav",
    attrs: {
      "facet": "base",
      "is-fixed": _vm.isFixed,
      "child": _vm.child
    }
  }) : _vm._e()], 1)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-32274a5c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32274a5c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/main-nav-item/index.vue
// module id = 528
// module chunks = 7